import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1c7a5d00&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "@/app/assets/styles/layout/_header.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1876123453/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c7a5d00')) {
      api.createRecord('1c7a5d00', component.options)
    } else {
      api.reload('1c7a5d00', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=1c7a5d00&", function () {
      api.rerender('1c7a5d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/layout/Header.vue"
export default component.exports